import { loadTemplate } from '../template/index.js';
import { handleSearch, handleInitialLoad } from './handlers.js';

/**
 * Initialize Recipe List Module
 */
export async function initRecipeList() {
	const recipesContainer = document.getElementById('recipes-list-container');
	const searchInput = document.querySelector('input[name="search"]');

	if (!recipesContainer) return;

	// Load templates
	await Promise.all([
		loadTemplate('recipe/item.ejs'),
		loadTemplate('recipe/list.ejs'),
		loadTemplate('recipe/empty.ejs')
	]);

	// Initial load
	await handleInitialLoad(recipesContainer);

	// Setup search listener
	if (searchInput) {
		searchInput.addEventListener('input', (e) => handleSearch(e, recipesContainer));
	}
}
